/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Empty_State_DescriptionInputs */

const fr_membership_empty_state_description = /** @type {(inputs: Membership_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement est géré directement par la salle. Contactez l'équipe pour toute question à ce sujet.`)
};

/**

* @param {Membership_Empty_State_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_empty_state_description = /** @type {((inputs?: Membership_Empty_State_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Empty_State_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_empty_state_description(inputs)
});